import type { Passage } from './passages';

/*
 * NARROWING A FIGURE'S PASSAGES to what the reader is looking for.
 *
 * A busy figure — Moses, David — opens to a hundred passages across several scriptures, and the old
 * complaint is that there was no way to get to the one you wanted. Two filters, composed:
 *
 *  - a free-text query, matched against the citation (so "Genesis", "1:1" or "12" find by book and by
 *    verse number), the English text, its second translation, AND the original-language text (so a
 *    reader who knows the Hebrew or Arabic word can find the verse by it too);
 *  - a set of corpora to hide, driven by the per-scripture chips, so a reader can look at one text
 *    at a time.
 *
 * It cannot match the opt-in MACHINE translation: that is produced per verse, on demand, on the reader's
 * device, and is never held in this list — filtering it would mean translating every passage up front,
 * the very cost the on-request design exists to avoid.
 *
 * Pure and order-preserving: it never reorders the passages, only removes, so reference order is
 * kept. Empty query and nothing hidden returns everything.
 */
export function filterPassages(
  passages: Passage[],
  query: string,
  hiddenCorpora?: ReadonlySet<string>,
): Passage[] {
  const q = query.trim().toLowerCase();
  return passages.filter(passage => {
    if (hiddenCorpora?.has(passage.corpusId)) return false;
    if (!q) return true;
    return passage.ref.toLowerCase().includes(q)
      || passage.text.toLowerCase().includes(q)
      || (passage.alt?.toLowerCase().includes(q) ?? false)
      || (passage.original?.toLowerCase().includes(q) ?? false);
  });
}
